export const MINIAPP_FID = 371274;
